import { Paper, Typography } from "@mui/material";
import { renderMultiLine } from "core/model/utils/text";
import {
  MESSAGING_BUBBLE_RECEIVED,
  MESSAGING_BUBBLE_SENT,
} from "ds_legacy/materials/colors";
import { dp, padding } from "ds_legacy/materials/metrics";
import { FONT_SIZE_14, LINE_HEIGHT_20 } from "ds_legacy/materials/typography";

export function EventMessagingBubbleV2({
  blur,
  isMyMessage,
  message,
}: {
  blur: boolean;
  isMyMessage: boolean;
  message?: string;
}) {
  if (!message) return null;

  return (
    <div
      data-testid="event_messaging_bubble"
      style={{
        display: "flex",
        justifyContent: isMyMessage ? "flex-end" : "flex-start",
        width: "100%",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          backgroundColor: isMyMessage
            ? MESSAGING_BUBBLE_SENT
            : MESSAGING_BUBBLE_RECEIVED,
          borderRadius: `${dp(16)} ${dp(16)} ${dp(isMyMessage ? 0 : 16)} ${dp(
            isMyMessage ? 16 : 0,
          )}`,
          maxWidth: { desktop: "55%", xs: "75%" },
          minWidth: dp(100),
          padding: padding(1.5),
          wordWrap: "break-word",
        }}
      >
        <Typography
          sx={{
            color: isMyMessage ? "common.white" : "common.black",
            fontSize: FONT_SIZE_14,
            lineHeight: LINE_HEIGHT_20,
          }}
        >
          {blur ? (
            <>
              <div dangerouslySetInnerHTML={{ __html: "&nbsp; &nbsp;" }} />
            </>
          ) : typeof message === "string" ? (
            renderMultiLine(message)
          ) : (
            message
          )}
        </Typography>
      </Paper>
    </div>
  );
}
